import { motion } from "framer-motion";

const FACTS = [
  { id: "sites", big: "2", text: "Live client sites + 1 demo build" },
  { id: "arizona", big: "AZ", text: "Arizona-based · Mon–Fri, 9am–5pm" },
  { id: "replies", big: "1 day", text: "Business-day reply on every inquiry" },
];

export default function FactsStrip() {
  return (
    <section
      data-tone="light"
      data-testid="facts-strip"
      className="tone-light relative bg-[#f6f5f1] border-y border-zinc-200"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 py-9 sm:py-12">
        <div className="flex items-center justify-center gap-4 text-[10.5px] sm:text-[11px] tracking-[0.24em] uppercase text-zinc-600">
          <span className="block w-8 sm:w-14 h-px bg-brand-600/60" />
          <span className="whitespace-nowrap">
            <span className="hidden sm:inline">Small team · </span>
            <span className="text-brand-700">Real client sites</span> · priced upfront
          </span>
          <span className="block w-8 sm:w-14 h-px bg-brand-600/60" />
        </div>
        <dl className="mt-7 sm:mt-9 grid grid-cols-3 sm:divide-x divide-zinc-200">
          {FACTS.map((f, i) => (
            <motion.div
              key={f.id}
              data-testid={`fact-${f.id}`}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="px-2 sm:px-6 text-center"
            >
              <dt className="font-display font-bold text-[30px] sm:text-5xl tracking-tight text-zinc-900 leading-none whitespace-nowrap">{f.big}</dt>
              <dd className="mt-2.5 text-[12px] sm:text-[13.5px] text-zinc-600 leading-snug max-w-[20ch] mx-auto">{f.text}</dd>
            </motion.div>
          ))}
        </dl>
      </div>
    </section>
  );
}
